import { render, staticRenderFns } from "./RedirectFromManager.vue?vue&type=template&id=6a8d1787&scoped=true"
import script from "./RedirectFromManager.vue?vue&type=script&lang=js"
export * from "./RedirectFromManager.vue?vue&type=script&lang=js"
import style0 from "./RedirectFromManager.vue?vue&type=style&index=0&id=6a8d1787&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d1787",
  null
  
)

export default component.exports